import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import NavData from "./navData";
import {
  ALL,
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  GET_FUNDS_LIST_FAILED,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  GET_SCHEME_LIST,
  GET_SCHEME_LIST_SUCCESS,
  GET_SCHEME_LIST_FAILED,
  REGULAR,
} from "../../../store/types";
import {
  getNewPurchaseFundList,
  getNavData,
  removeNavData,
} from "../../../store/actions";
import { connect } from "react-redux";
import CustomizedSelect from "../transactions/customizedSelect";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
export const NAV_URL = `/nav`;
class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fund: { value: "189" },
      category: { value: "" },
      scheme: { value: "" },
      time: "1D",
    };
  }

  componentDidMount() {
    const params = {
      opt: ALL,
      plntype: REGULAR,
      opt: "AT",
      fund: "189",
    };
    const types = [
      GET_CATEGORY_LIST,
      GET_CATEGORY_LIST_SUCCESS,
      GET_CATEGORY_LIST_FAILED,
    ];
    this.props.getNewPurchaseFundList(params, types);

    this.props.removeNavData();
    this.setState({
      category: { value: "" },
      scheme: { value: "" },
      time: "1D",
    });
  }

  // handleFundChange = async (value) => {
  //   if (!!value) {
  //     const params = { plntype: REGULAR, opt: "AT", fund: value.value };
  //     const types = [
  //       GET_CATEGORY_LIST,
  //       GET_CATEGORY_LIST_SUCCESS,
  //       GET_CATEGORY_LIST_FAILED,
  //     ];
  //     await this.props.getNewPurchaseFundList(params, types);
  //     this.props.removeNavData();
  //   }
  //   this.setState({

  //     category: { value: "" },
  //     scheme: { value: "" },
  //     time: "1D",
  //   });

  //   if (!value) {
  //     this.props.removeNavData();
  //   }
  // };

  handleChange = (label) => async (event) => {
    this.setState({ [label]: { value: event.target.value } });
    if (!!event.target.value) {
      const params = {
        plntype: REGULAR,
        opt: "S",
        schemetype: event.target.value,
        fund: "189",
      };
      const types = [
        GET_SCHEME_LIST,
        GET_SCHEME_LIST_SUCCESS,
        GET_SCHEME_LIST_FAILED,
      ];
      await this.props.getNewPurchaseFundList(params, types);
    }
    this.setState({
      category: { value: event.target.value },
      scheme: { value: "" },
    });
    this.props.removeNavData();
  };

  changeScheme = (value) => {
    this.setState({
      scheme: { value },
    });
    if (!!value) {
      const plan = value.value.split("~");
      const params = {
        Plan: plan[2],
        flag: this.state.time,
        Fund: "189",
        Scheme: plan[1],
      };
      this.props.getNavData(params);
    }
    if (!value) {
      this.props.removeNavData();
    }
  };

  changeTime = (value) => () => {
    this.setState({
      time: value,
    });
    const { scheme } = this.state;
    if (!!scheme.value) {
      const plan = scheme.value.value.split("~");
      const params = {
        Plan: plan[2],
        flag: value,
        Fund: "189",
        Scheme: plan[1],
      };
      this.props.getNavData(params);
    }
  };

  render() {
    const { fundsList, schemeList, categoryList } = this.props;
    const { fund, category, scheme, time } = this.state;
    return (
      <div className="container-margin nav-margin">
        <div className="investor-title" style={{ marginBottom: 30 }}>
          NAV Graph & NAV Table
        </div>
        <Paper className="flex nav-paper">
          <div className="nav-left-container">
            {/* <div className="input-margin" style={{ margin: "30px 0px" }}>
              <div className="input-name input-integrated-label">AMC</div>
              <BajajFund /> */}
            {/* </div> */}
            <div className="input-margin" style={{ margin: "30px 0px" }}>
              <CustomizedSelect
                name="Category"
                handleChange={this.handleChange("category")}
                value={category.value}
                placeholder="Select Category"
                disabled={!fund.value}
                borderColor="#a6a6a6"
              >
                {categoryList.map((item, index) => (
                  <MenuItem value={item.fm_subcategory} key={index}>
                    {item.fm_subcategory}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </div>
            <div className="input-margin" style={{ margin: "30px 0px" }}>
              <div className="input-name input-integrated-label">Scheme</div>
              <IntegrationReactSelect
                suggestions={schemeList.map((item) => ({
                  label: item.Scheme_Desc,
                  value: item.Scheme_Plan,
                }))}
                value={scheme.value}
                placeholder="Select Scheme"
                handleChange={this.changeScheme}
                disabled={!category.value}
              />
            </div>
            <div className="nav-dragger-names-div">
              <div
                className={
                  time === "1D"
                    ? "nav-dragger-name-active"
                    : "nav-dragger-names"
                }
                onClick={this.changeTime("1D")}
              >
                1 W
              </div>
              <div
                className={
                  time === "1M"
                    ? "nav-dragger-name-active"
                    : "nav-dragger-names"
                }
                onClick={this.changeTime("1M")}
              >
                1 Mon
              </div>
              <div
                className={
                  time === "3M"
                    ? "nav-dragger-name-active"
                    : "nav-dragger-names"
                }
                onClick={this.changeTime("3M")}
              >
                3 Mon
              </div>
              <div
                className={
                  time === "1Y"
                    ? "nav-dragger-name-active"
                    : "nav-dragger-names"
                }
                onClick={this.changeTime("1Y")}
              >
                1 Yr
              </div>

              <div
                className={
                  time === "3Y"
                    ? "nav-dragger-name-active"
                    : "nav-dragger-names"
                }
                onClick={this.changeTime("3Y")}
              >
                3 Yr
              </div>
              <div
                className={
                  time === "5Y"
                    ? "nav-dragger-name-active"
                    : "nav-dragger-names"
                }
                onClick={this.changeTime("5Y")}
              >
                5 Yr
              </div>
            </div>
          </div>
          <div className="nav-right-container">
            <NavData />
            {/* <DebtbuttonActive buttontitle="INITIATE" /> */}
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ transactions }) => {
    const { fundsList, schemeList, categoryList } = transactions;
    return { fundsList, schemeList, categoryList };
  },
  { getNewPurchaseFundList, getNavData, removeNavData }
)(Nav);

export class BajajFund extends Component {
  render() {
    return (
      <div
        style={{
          border: "1px solid rgba(166,166,166,0.9)",
          borderRadius: 3,
          marginTop: 10,
          padding: "12px 15px",
          minHeight: 50,
        }}
      >
        <div
          style={{
            fontSize: 15,
            letterSpacing: 0.5,
            color: "#043b72",
          }}
        >
          Bajaj Asset Mutual Fund
        </div>
      </div>
    );
  }
}
